import { required, email, minLength, minValue } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import isProduction from "../helpers/isProduction";

export type BillingDetailModel = {
  company: string | null;
  billingContactName: string | null;
  billingEmail: string | null;
  vatNumber: string | null;
  address1: string | null;
  address2: string | null;
  address3: string | null;
  cityTown: string | null;
  stateRegion: string | null;
  postalCode: string | null;
  country: string | null;
}

export type RegistrationModel = {
  courseName: string;
  name: string;
  email: string;
  numberSeats: number;
  phoneNumber: string | null;
  comments: string | null;
  billingDetail: BillingDetailModel | null;
}


export default class Registration {

  constructor() {
    this.reset();
  }

  registration = {} as RegistrationModel;

  rules = {
    courseName: { required },
    name: { required, minLength: minLength(5) },
    email: { required, email },
    phoneNumber: { },
    numberSeats: { required, minValue: minValue(1) },
    comments: {},
    billingDetail: {
      company: { },
      billingContactName: { },
      billingEmail: { email },
      vatNumber: { },
      address1: { },
      address2: { },
      address3: { },
      cityTown: { },
      stateRegion: { },
      postalCode: { },
      country: { }
    }
  };

  getModel() {
    return useVuelidate(this.rules, this.registration, { $rewardEarly: true });
  }

  reset() {
    this.registration.name = "";
    this.registration.email = "";
    this.registration.phoneNumber = "";
    this.registration.numberSeats = 1;
    this.registration.comments = "";
    this.registration.courseName = "";
    this.registration.billingDetail = {
      company: "",
      billingContactName: "",
      billingEmail: "",
      vatNumber: "",
      address1: "",
      address2: "",
      address3: "",
      cityTown: "",
      stateRegion: "",
      postalCode: "",
      country: ""
    } as BillingDetailModel;
  }
}